import Skeleton from '@mui/material/Skeleton';
import { CardContent } from 'shared/mui/Card/CardContent/CardContent';

import {
  OrderProviderExternalErrorsRatioChartHintBox,
  OrderProviderExternalErrorsRatioChartScrollBox,
  OrderProviderExternalErrorsRatioChartTotalStyled,
  StyledCard,
  StyledCardHeader,
} from './OrderProviderExternalErrorsRatioChart.styled';
import { OrderProviderExternalErrorsRatioChartBarSkeleton } from './OrderProviderExternalErrorsRatioChartBarSkeleton';

export const OrderProviderExternalErrorsRatioChartSkeleton: React.FC = () => (
  <StyledCard>
    <StyledCardHeader
      title={
        <>
          <Skeleton variant="text" width={200} />
          <Skeleton sx={{ fontSize: '12px' }} variant="text" width={160} />
        </>
      }
      titleSize="small"
    />
    <CardContent sx={{ padding: '0 !important' }}>
      <OrderProviderExternalErrorsRatioChartTotalStyled>
        <OrderProviderExternalErrorsRatioChartBarSkeleton />
      </OrderProviderExternalErrorsRatioChartTotalStyled>
      <OrderProviderExternalErrorsRatioChartScrollBox>
        {Array.from({ length: 5 }).map((_, index) => (
          <OrderProviderExternalErrorsRatioChartBarSkeleton key={index} />
        ))}
      </OrderProviderExternalErrorsRatioChartScrollBox>
      <OrderProviderExternalErrorsRatioChartHintBox>
        <Skeleton sx={{ fontSize: '12px' }} variant="text" width={80} />
        <Skeleton sx={{ fontSize: '12px' }} variant="text" width={80} />
      </OrderProviderExternalErrorsRatioChartHintBox>
    </CardContent>
  </StyledCard>
);
